import { render, staticRenderFns } from "./RealmsSingle.vue?vue&type=template&id=c3b56e06&scoped=true&"
import script from "./RealmsSingle.vue?vue&type=script&lang=js&"
export * from "./RealmsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b56e06",
  null
  
)

export default component.exports